export enum EstateTaskEditorTemplateDocumentTypeKey {
  QA_REVIEWER = 'qa_reviewer',
  APPROVE_DOCUMENT = 'approve_document'
}
